// 存放 Vue mixin 可混入的代码
// 本可做全局的混入，但是对于 Vue 理解还不足，所以 impor 导入方式
'use strict'
/**
 * 上传头像
 * zlh
 */

import DATASETLOBBY from '@/axios/datasetLobby/datasetLobby.js'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'
export const DictType = {
  data() {
    return {
      // 数据集类型
      dictTypeList: [],
    }
  },
  mounted() {},

  methods: {
    getDataSetType(dictTypeCode) {
      var data = {
        dictTypeCode: dictTypeCode,
      }
      return PERSONAL.getComDictionary(data).then((result) => {
        if (result.isSuccess) {
          if (dictTypeCode == 'EditorType') {
            this.editorTypeList = result.data
            sessionStorage.editorTypeList = JSON.stringify(result.data)
            this.$store.dispatch('setEditorTypeList', {
              editorTypeList: result.data,
            })
          }
          this.dictTypeList = result.data
          return result.data
        }
      })
    },
    // 上传类型检测
    datasetTypeCheck(typeId, typeDescs) {
      return this.dictTypeList.some(
        (item) =>
          item.dictId === typeId && typeDescs.includes(item.dictTypeDesc)
      )
    },
    // 获取类型的名称
    getTypeName(typeId) {
      return this.dictTypeList.find((item) => item.dictId === typeId)
        .dictTypeDesc
    },
  },
}
